define("shared/components/shared/creator-profile-modal", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@close}} as |modal|>
    <modal.card @closeIcon={{true}} @portrait={{true}}>
      <modal.card-header @title={{t "account.creator_profile.modal.title"}} />
      <modal.card-body class="u--p__t__xs">
        <p>
          {{t "account.creator_profile.modal.paragraph_one"}}
        </p>
        <p>
          {{t "account.creator_profile.modal.paragraph_two"}}
        </p>
        <p>
          {{t "account.creator_profile.modal.paragraph_three"}}
        </p>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button @variant="outline" class="u--float--right" {{on "click" @close}}>
          {{t "shared_words.close"}}
        </Shared::Ui::Button>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "v581Re7l",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@closeIcon\",\"@portrait\"],[true,true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"account.creator_profile.modal.title\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__xs\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.creator_profile.modal.paragraph_one\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.creator_profile.modal.paragraph_two\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.creator_profile.modal.paragraph_three\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,2],[[24,0,\"u--float--right\"],[4,[38,3],[\"click\",[30,1]],null]],[[\"@variant\"],[\"outline\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,1],[\"shared_words.close\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@close\",\"modal\"],false,[\"shared/modal\",\"t\",\"shared/ui/button\",\"on\"]]",
    "moduleName": "shared/components/shared/creator-profile-modal.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});